import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { getProducts, getSettings, DEFAULT_HERO_BANNER } from "@/lib/api";
import { resolveImage } from "@/lib/adminApi";
import { ProductCard } from "@/components/ProductCard";
import { TrustBand } from "@/components/TrustBand";

export default function Home() {
  const { data: products = [] } = useQuery({ queryKey: ["products"], queryFn: getProducts });
  const { data: s, isLoading: sLoading } = useQuery({ queryKey: ["settings"], queryFn: getSettings });
  const banner = s?.hero_banner_image ? resolveImage(s.hero_banner_image) : DEFAULT_HERO_BANNER;

  return (
    <div data-testid="home-page">
      {/* HERO BANNER (imagine) */}
      <section className="bg-navy" data-testid="hero-banner">
        <Link to={s?.hero_banner_link || "/produse"} className="block max-w-[1400px] mx-auto" aria-label="Comandă acum">
          {!sLoading && (
            <img
              src={banner}
              alt={s?.hero_title || "DeterShop - detergenți lichizi concentrați"}
              className="w-full h-auto"
              data-testid="hero-banner-image"
            />
          )}
        </Link>
        {(s?.hero_title || s?.hero_subtitle) && (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-center">
            {s.hero_title && (
              <h1 className="font-display font-black text-white text-3xl md:text-4xl tracking-tight" data-testid="hero-title">{s.hero_title}</h1>
            )}
            {s.hero_subtitle && (
              <p className="text-white/75 mt-2 max-w-2xl mx-auto" data-testid="hero-subtitle">{s.hero_subtitle}</p>
            )}
          </div>
        )}
      </section>

      {/* PROMO STRIP */}
      <section className="bg-gold" data-testid="promo-strip">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center">
            <span className="font-display font-black text-navy text-xl sm:text-2xl tracking-tight">PACHET MIX 3 x 5L</span>
            <span className="bg-navy text-white font-display font-black text-lg sm:text-xl px-4 py-1.5 rounded-lg">
              DOAR 144 LEI
            </span>
            <span className="font-display font-black text-navy text-lg sm:text-xl">
              TRANSPORT GRATUIT!
            </span>
          </div>
        </div>
      </section>

      {/* PRODUCTS */}
      <section className="bg-slate-50" data-testid="products-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        </div>
      </section>

      <TrustBand />
    </div>
  );
}
